import { render } from "./UyduButton.vue?vue&type=template&id=5ac6e2b0&scoped=true"
import script from "./UyduButton.vue?vue&type=script&lang=js"
export * from "./UyduButton.vue?vue&type=script&lang=js"

import "./UyduButton.vue?vue&type=style&index=0&id=5ac6e2b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac6e2b0"]])

export default __exports__